module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-editor', {
    attrs: {
      "mode": "create"
    },
    on: {
      "saveClicked": _vm.registerUser,
      "cancelClicked": _vm.onCancelClick
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-84511e80", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84511e80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/accounts/register-user-dialog.vue.html
// module id = 1124
// module chunks = 0